import { useEffect, useState, useMemo } from 'react';
import {
	getActivityListLevelCount,
	getActivityListGradeLevelCount,
	getActivityListPositionCount,
	getActivityListWeeksPerYearCount,
	getActivityListCategoryCount,
	getOverviewTexts,
	saveOverviewTexts,
} from '../../../lib/studentactivityreport';
import style from './globalstudentcourselessonreport.module.css';
import { Toast, ToastContainer } from 'react-bootstrap';


const consistencyTypes = {
				'9': style.studentActivityRed,
				'10': style.studentActivityRed,
				'11': style.studentActivityRed,
				'12': style.studentActivityRed,
				'9-12': style.studentActivityBlue,
				'10-12': style.studentActivityGreen,
				'9-11': style.studentActivityYellow,
				'9-10': style.studentActivityOrange,
				'10-11': style.studentActivityOrange,
				'11-12': style.studentActivityLightRed,
			};

const RecognitionTable = ({ recognition, overview, onOverviewChange }) => (
	<>
		<h5 className='mb-3'>RECOGNITION</h5>
		<table className='table table-bordered text-center'>
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Level</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{recognition.map((r, index) => {
					const rowCount = recognition.length + 1; // +1 for TOTAL row
					return (
						<tr key={`recognition-${r.Level}`}>
							<td>{r.Level}</td>
							<td className={r.Color}>{r.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} className={style.overviewCell}>
									<div className='h-100 w-100'>
										<textarea
											rows={rowCount * 2}
											className='form-control flex-grow-1'
											value={overview['recognition'] || ''}
											onChange={(e) =>
												onOverviewChange('recognition', e.target.value)
											}
										/>
									</div>
								</td>
							)}
						</tr>
					);
								})}
								{/* TOTAL row */}
								<tr>
									<td><strong>TOTAL</strong></td>
									<td className={style.totalCell}>{recognition.reduce((s, it) => s + (it.Count || 0), 0)}</td>
									<td></td>
								</tr>
			</tbody>
		</table>
	</>
);

const ConsistencyTable = ({ consistency, overview, onOverviewChange }) => (
	<>
		<h5 className='mb-3'>CONSISTENCY</h5>
		<table className='table table-bordered text-center'>
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Duration</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{consistency.map((c, index) => {
					const rowCount = consistency.length + 1; // +1 for TOTAL row

					return (
						<tr key={`consistency-${c.Grade}`}>
							<td>{c.Grade}</td>
							<td className={consistencyTypes[c.Grade]}>{c.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} className={style.overviewCell}>
									<div className='h-100 w-100'>
										<textarea
											rows={rowCount * 2}
											className='form-control flex-grow-1'
											value={overview['consistency'] || ''}
											onChange={(e) =>
												onOverviewChange('consistency', e.target.value)
											}
										/>
									</div>
								</td>
							)}
						</tr>
					);
								})}
								{/* TOTAL row */}
								<tr>
									<td><strong>TOTAL</strong></td>
									<td className={style.totalCell}>{consistency.reduce((s, it) => s + (it.Count || 0), 0)}</td>
									<td></td>
								</tr>
			</tbody>
		</table>
	</>
);

const ImpactTable = ({ impact, overview, onOverviewChange }) => (
	<>
		<h5 className='mb-3'>IMPACT</h5>
		<table className='table table-bordered text-center'>
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Position</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{impact.map((i, index) => {
					const rowCount = impact.length + 1; // +1 for TOTAL row
					return (
						<tr key={`impact-${i.Position}`}>
							<td>{i.Position}</td>
							<td className={i.Color}>{i.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} className={style.overviewCell}>
									<div className='h-100 w-100'>
										<textarea
											rows={rowCount * 2}
											className='form-control flex-grow-1'
											value={overview['impact'] || ''}
											onChange={(e) =>
												onOverviewChange('impact', e.target.value)
											}
										/>
									</div>
								</td>
							)}
						</tr>
					);
								})}
								{/* TOTAL row */}
								<tr>
									<td><strong>TOTAL</strong></td>
									<td className={style.totalCell}>{impact.reduce((s, it) => s + (it.Count || 0), 0)}</td>
									<td></td>
								</tr>
			</tbody>
		</table>
	</>
);

const CommitmentTable = ({ commitment, overview, onOverviewChange }) => (
	<>
		<h5 className='mb-3'>COMMITMENT</h5>
		<table className='table table-bordered text-center'>
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Weeks/Year</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{commitment.map((c, index) => {
					const rowCount = commitment.length + 1; // +1 for TOTAL row

					return (
						<tr key={`commitment-${c.Weeks}`}>
							<td>{c.Weeks}</td>
							<td className={c.Color}>{c.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} className={style.overviewCell}>
									<div className='h-100 w-100'>
										<textarea
											rows={rowCount * 2}
											className='form-control flex-grow-1'
											value={overview['commitment'] || ''}
											onChange={(e) =>
												onOverviewChange('commitment', e.target.value)
											}
										/>
									</div>
								</td>
							)}
						</tr>
					);
								})}
								{/* TOTAL row */}
								<tr>
									<td><strong>TOTAL</strong></td>
									<td className={style.totalCell}>{commitment.reduce((s, it) => s + (it.Count || 0), 0)}</td>
									<td></td>
								</tr>
			</tbody>
		</table>
	</>
);

const VarietyTable = ({ variety, overview, onOverviewChange }) => (
	<>
		<h5 className='mb-3'>VARIETY</h5>
		<table className='table table-bordered text-center'>
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Category</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{variety.map((v, index) => {
					const rowCount = variety.length + 1; // +1 for TOTAL row
					return (
						<tr key={`variety-${v.Category}`}>
							<td>{v.Category}</td>
							<td className={v.Color}>{v.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} className={style.overviewCell}>
									<div className='h-100 w-100'>
										<textarea
											rows={rowCount * 2}
											className='form-control flex-grow-1'
											value={overview['variety'] || ''}
											onChange={(e) =>
												onOverviewChange('variety', e.target.value)
											}
										/>
									</div>
								</td>
							)}
						</tr>
					);
								})}
								{/* TOTAL row */}
								<tr>
									<td><strong>TOTAL</strong></td>
									<td className={style.totalCell}>{variety.reduce((s, it) => s + (it.Count || 0), 0)}</td>
									<td></td>
								</tr>
			</tbody>
		</table>
	</>
);

export default function GlobalStudentCourseLessonReport({ studentId }) {
	const [recognition, setRecognition] = useState([]);
	const [consistency, setConsistency] = useState([]);
	const [impact, setImpact] = useState([]);
	const [commitment, setCommitment] = useState([]);
	const [variety, setVariety] = useState([]);
	const [overview, setOverview] = useState([]);
	const [toastMessage, setToastMessage] = useState('');
	const [showToast, setShowToast] = useState(false);

	const loadData = async () => {
		//console.log('loadData called');
		const overviewRes = await getOverviewTexts(studentId);

		const loadRecognition = async () => {
			const recognitionRes = await getActivityListLevelCount(studentId);
			const recognitionTypes = {
				International: style.studentActivityBlue,
				National: style.studentActivityGreen,
				Regional: style.studentActivityYellow,
				State: style.studentActivityOrange,
				City: style.studentActivityLightRed,
				School: style.studentActivityRed,
			};

			// map each recognition type to its level
			const recognitionMap = recognitionRes.reduce((acc, item) => {
				const level = item.Level;

				if (recognitionTypes[level]) {
					acc[level] = {
						Level: level,
						Count: item.Count,
						Color: recognitionTypes[level],
					};
				} else {
					acc[level] = {
						Level: level,
						Count: item.Count,
						Color: style.studentActivityDefault,
					};
				}
				return acc;
			}, {});

			//console.log("recognitionMap",recognitionMap);
			

			setRecognition(Object.values(recognitionMap));
		};
		const loadConsistency = async () => {
			const consistencyRes = await getActivityListGradeLevelCount(studentId);
			//console.log('consistencyRes', consistencyRes);
			/*
			const consistencyTypes = {
				'9': style.studentActivityRed,
				'10': style.studentActivityRed,
				'11': style.studentActivityRed,
				'12': style.studentActivityRed,
				'9-12': style.studentActivityBlue,
				'10-12': style.studentActivityGreen,
				'9-11': style.studentActivityYellow,
				'9-10': style.studentActivityOrange,
				'10-11': style.studentActivityOrange,
				'11-12': style.studentActivityLightRed,
			};

			

			const consistencyMap = consistencyRes.reduce((acc, item) => {
				
				
				if (consistencyTypes[item.Grade]) {
					//console.log("item.Grade",consistencyTypes[item.Grade]);
					
					acc[item.Grade] = {
						Grade: item.Grade,
						Count: item.Count,
						Color: consistencyTypes[item.Grade],
					};
				}
				
				else if (['9', '10', '11', '12'].includes(item.Grade)) {
					// Handle the case where Grade is 9, 10, 11, or 12
					const gradeKey = '9, 10, 11, 12';
					acc[gradeKey] = {
						Grade: gradeKey,
						Count: item.Count + acc[gradeKey]?.Count || 0,
						Color: consistencyTypes[gradeKey],
					};
				} else {
					// map it with default color if not found
					acc[item.Grade] = {
						Grade: item.Grade,
						Count: item.Count,
						Color: style.studentActivityDefault,
					};
				}			

					
								
				return acc;
			}, {});
			
*/
// const sortedData = Object.values(consistencyMap).sort((a, b) => b.Grade.localeCompare(a.Grade));

//			console.log("sortedData",sortedData);
			

			setConsistency(consistencyRes);
		};
		const loadImpact = async () => {
			const impactRes = await getActivityListPositionCount(studentId);
			const impactTypes = {
				Founder: style.studentActivityBlue,
				President: style.studentActivityGreen,
				Officer: style.studentActivityYellow,
				Organizer: style.studentActivityOrange,
				Helper: style.studentActivityLightRed,
				Member: style.studentActivityRed,
			};

			const positionCodes = {
				'1.FDR': 'Founder',
				'2.PRS': 'President',
				'3.OFC': 'Officer',
				'4.ORG': 'Organizer',
				'5.HLP': 'Helper',
				'6.MBR': 'Member',
			};
			const impactMap = impactRes.reduce((acc, item) => {
				// item.Position will be one of the positionCodes, we should convert it to the full name
				const position = positionCodes[item.Position] || item.Position;

				acc[position] = {
					Position: position,
					Count: item.Count,
					Color: impactTypes[position] || style.studentActivityDefault,
				};
				return acc;
			}, {});



			setImpact(Object.values(impactMap));
		};
		const loadCommitment = async () => {
			const commitmentRes = await getActivityListWeeksPerYearCount(studentId);
			console.log('commitmentRes', commitmentRes);
			
			const commitmentTypes = {
				'41-50': style.studentActivityBlue,
				'31-40': style.studentActivityGreen,
				'21-30': style.studentActivityYellow,
				'11-20': style.studentActivityOrange,
				'6-10': style.studentActivityLightRed,
				'0-5': style.studentActivityRed,
			};

			const commitmentMap = commitmentRes.reduce((acc, item) => {
				acc.push({
					Weeks: item.range,
					Count: item.Count,
					Color: commitmentTypes[item.range] || style.studentActivityDefault,
				});

				return acc;
			}, []);

			const sortedData = commitmentMap.sort((a, b) => a.Weeks.localeCompare(b.Weeks));
			//console.log("sortedData",sortedData);

			setCommitment(sortedData);
		};
		const loadVariety = async () => {
			const varietyRes = await getActivityListCategoryCount(studentId);
			const categoryCodes = {
				'A/R/P': 'Academic/Research/Publication',
				Career: 'Career-Oriented',
				Intern: 'Internship',
				Service: 'Community Service',
				'Db/Gov': 'Debate/Speech/Student Govt',
				Sports: 'Athletics Team',
				Arts: 'Art/Music/Theater/Dance',
				Family: 'Family Responsibility',
				Work: 'Work',
				Clubs: 'Others/Clubs',
			};

			//console.log('varietyRes', varietyRes);

			const varietyMap = varietyRes.reduce((acc, item) => {
				// item.Category will be one of the categoryCodes, we should convert it to the full name
				const category = categoryCodes[item.Category] || item.Category;

				acc[category] = {
					Category: category,
					Count: item.Count,
					Color: style.studentActivityDefault,
				};
				return acc;
			}, {});

			setVariety(Object.values(varietyMap));
			//console.log('varietyMap', varietyMap);
		};

		await Promise.all([
			loadRecognition(),
			loadConsistency(),
			loadImpact(),
			loadCommitment(),
			loadVariety(),
		]);

		const overviewMap = {};
		overviewRes.forEach((item) => {
			overviewMap[item.type] = item.desc;
		});

		setOverview(overviewMap);
	};

	const showToastMessage = (message) => {
		setToastMessage(message);
		setShowToast(true);
		setTimeout(() => setShowToast(false), 3000);
	};

	const handleOverviewChange = (key, value) => {
		console.log('handleOverviewChange called');

		setOverview((prev) => ({ ...prev, [key]: value }));
	};

	const handleUpdate = async () => {
		console.log('handleUpdate called');
		await saveOverviewTexts(studentId, overview);
		showToastMessage('Update successful!');
		await loadData();
	};

	useEffect(() => {
		console.log('useEffect called');
		loadData();
	}, [studentId]);

	return (
		<div className='card p-3'>
			<h4 className='mb-3'>Activity Reports</h4>
			<ToastContainer style={{ bottom: '1rem', right: '1rem', position: 'fixed' }}>
				<Toast show={showToast} onClose={() => setShowToast(false)} delay={2000} autohide>
					<Toast.Header>
						<strong className='me-auto'>Notification</strong>
					</Toast.Header>
					<Toast.Body>{toastMessage}</Toast.Body>
				</Toast>
			</ToastContainer>

			<RecognitionTable
				recognition={recognition}
				onOverviewChange={handleOverviewChange}
				overview={overview}
			/>
			<ConsistencyTable
				consistency={consistency}
				onOverviewChange={handleOverviewChange}
				overview={overview}
			/>
			<ImpactTable
				impact={impact}
				onOverviewChange={handleOverviewChange}
				overview={overview}
			/>

			<CommitmentTable
				commitment={commitment}
				onOverviewChange={handleOverviewChange}
				overview={overview}
			/>

			<VarietyTable
				variety={variety}
				onOverviewChange={handleOverviewChange}
				overview={overview}
			/>

			<div className='text-max text-end'>
				<button className='btn btn-primary' onClick={handleUpdate}>
					Update
				</button>
			</div>
		</div>
	);
}
